import { render, staticRenderFns } from "./Statuses.vue?vue&type=template&id=9215fdd6&scoped=true"
import script from "./Statuses.vue?vue&type=script&lang=js"
export * from "./Statuses.vue?vue&type=script&lang=js"
import style0 from "./Statuses.vue?vue&type=style&index=0&id=9215fdd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9215fdd6",
  null
  
)

export default component.exports